import { useEffect } from 'react';

import { cartStore } from '@/entities/cart/store/cartStore';
import { CartDetails } from '@/entities/cart/ui/CartFooter/CartDetails';
import { CartItemsList } from '@/entities/cart/ui/CartItemsList/CartItemsList';
import { CartPayButton } from '@/entities/cart/ui/CartPayButton/CartPayButton';
import { restaurantStore } from '@/entities/restaurant/store/restaurantStore';
import { observer } from '@/shared/lib/signal/observer';
import { uiStore } from '@/shared/stores/uiStore';
import { Modal } from '@/shared/ui-kit/Modal/Modal';

export const Cart = observer(
  ({ open, onClose }: { open: boolean; onClose: () => void }) => {
    const total = cartStore.total.value;
    const itemsCount = cartStore.items.value.length;

    const header = restaurantStore.headerInfo;
    const title = header?.name ?? '';
    const logoSrc = header?.image || undefined;

    useEffect(() => {
      if (!open) return;
      if (itemsCount === 0) {
        uiStore.closeCart();
      }
    }, [open, itemsCount]);

    if (!open || itemsCount === 0) {
      return null;
    }

    return (
      <>
        <Modal
          open={open}
          onClose={onClose}
          title={title}
          closable
          fullScreen
          logoSrc={logoSrc}
          fixedBar={<CartPayButton total={total} />}
        >
          <CartItemsList />

          <CartDetails />
        </Modal>
      </>
    );
  }
);
